import { ArrowUpRight } from "lucide-react";
import { Reveal, Tag, Heading } from "../Reveal";
import { scrollToTarget } from "../../lib/scroll";

const SERVICES = [
  { num: "01", name: "Residential remodeling", desc: "Transform your home with expert kitchen, bathroom, and whole-house renovations.", img: "/images/home/svc-residential.jpg" },
  { num: "02", name: "Light commercial", desc: "Professional buildouts and renovations for offices, retail spaces, and more.", img: "/images/home/svc-commercial.jpg" },
  { num: "03", name: "New construction", desc: "Expand your living space with custom additions, decks, and outdoor structures.", img: "/images/home/svc-additions.jpg" },
  { num: "04", name: "Custom carpentry", desc: "Precision craftsmanship for built-ins, cabinetry, and custom millwork.", img: "/images/home/svc-carpentry.jpg" },
];

export const HomeServices = () => (
  <section id="services" className="py-24 lg:py-40" data-testid="home-services-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <Reveal className="lg:col-span-7">
          <Tag>Our services</Tag>
          <Heading className="mt-6">From residential remodels to light commercial builds.</Heading>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.1}>
          <p className="text-base sm:text-lg text-ink/70 leading-relaxed">We deliver quality craftsmanship on every job — large or small, home or business.</p>
        </Reveal>
      </div>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.08} className="bg-bone">
            <button onClick={() => scrollToTarget("#estimate")} className="group block w-full text-left h-full" data-testid={`home-service-${i}`}>
              <div className="overflow-hidden aspect-[4/3]">
                <img src={s.img} alt={s.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              </div>
              <div className="p-6 sm:p-7">
                <div className="flex items-center justify-between">
                  <span className="font-mono text-xs text-ink/40">{s.num}</span>
                  <ArrowUpRight className="h-5 w-5 text-ink/30 transition-all duration-300 group-hover:text-teal group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </div>
                <h3 className="mt-4 font-display font-medium text-2xl tracking-[-0.015em] text-ink group-hover:text-teal transition-colors duration-300">{s.name}</h3>
                <p className="mt-3 text-sm sm:text-base text-ink/65 leading-relaxed">{s.desc}</p>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
